import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GeneralService } from 'src/app/services/general/general.service';


@Component({
  selector: 'app-chat-conversation',
  templateUrl: './chat-conversation.component.html',
  styleUrls: ['./chat-conversation.component.scss'],
})
export class ChatConversationComponent
  implements OnInit, OnDestroy, AfterViewInit {
  private _chatSelected: FormControl = new FormControl(null);
  public subscriptions: any = [];
  public messages: any = [];
  public loading: any = false;
  public sendingMessage: any = false;

  public user: any;
  public userInfo: any;
  
  public intervalCheck: any;
  public noloadMore: any = false;
  public chatPageWidth: any = 0;
  public form: FormGroup;

  @Input() minimized: any = false;
  @Input() get chatSelected() {
    return this._chatSelected.value;
  }
  set chatSelected(value) {
    this._chatSelected.patchValue(value);
  }

  constructor(private general: GeneralService, public fb: FormBuilder) {
    this.form = this.fb.group(
      {
        message: [''],
        file: [''],
      },
      { validators: this.validateForm() }
    );

    this.intializeSubscriptions();


  

  }



  async ngOnInit() {

    try {

      window.addEventListener('app:new-message', this);
      this.loading = true;

      await this.getUserInfo();

    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  


 
  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  ngAfterViewInit() {
    const element: any = document.getElementById('chat-page');
    this.chatPageWidth = element?.clientWidth;
  }

  ngOnDestroy() {
    window.removeEventListener('app:new-message', this);

    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });

    clearInterval(this.intervalCheck);
  }

  // Handle event Listener
  async handleEvent(event: any) {
    
    switch (event.type) {
      case 'app:new-message':
        await this.addNewMessageFromEvent(event.detail.message);
        break;
    }
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this._chatSelected.valueChanges.pipe().subscribe(async (data) => {
        if (!data) {
          return;
        }
        await this.loadInitialDataChat(data);
      }),
    ];
  }

  async loadInitialDataChat(data: any) {
    try {
      this.loading = true;
      const response = await this.general.httpGet('chat/load-recent-messages', {
        user_id: data,
      });

      this.messages = this.formatMessages(
        response.data.sort(this.sortMessages)
      );
      await this.general.sleep(10);

      await this.scrollToBottom();
      clearInterval(this.intervalCheck);
      this.initInterval();
    } catch (error) {
      console.log(error);
      await this.general.showDanger();
    } finally {
      this.loading = false;
      const response = await this.general.httpGet('chat/load-chat-list');
      let chatsTemporal = response.data;
      let notReadChatsCountTemporal = 0;
      chatsTemporal.forEach((chat: any) => {
        notReadChatsCountTemporal += chat.count;
      });
      localStorage.setItem('noReadChats', JSON.stringify(notReadChatsCountTemporal));
    }

  }

  sortMessages(a: any, b: any) {
    if (a.id > b.id) {
      return 1;
    }
    return -1;
  }
  showConversations(): void {
    window.location.reload();
}

  formatMessages(messages: any) {
    return messages.map((message: any) => {
      return this.formatMessage(message);
    });
  }

  formatMessage(message: any) {
    return {
      ...message,
      align:
        this.user.id === message.from_user.id
          ? 'text-right'
          : 'text-left',
      type:
        this.user.id === message.from_user.id
          ? 'message-sent'
          : 'message-received',
    };
  }

  async addNewMessageFromEvent(message: any) {
    this.messages.push(this.formatMessage(message));
    await this.general.sleep(10);

    await this.scrollToBottom();
  }

  isAtTop() {
    const element = document.getElementById('check-top');
    if (!element) return;
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  async loadMoreMessages() {
    try {
      if (!this.messages.length) {
        this.noloadMore = true;
        clearInterval(this.intervalCheck);
        return;
      }

      this.loading = true;
      const currentMessageId = this.messages[0].id;
      const response = await this.general.httpGet('chat/fetch-old-messages', {
        to_user: this.chatSelected,
        old_message_id: this.messages[0].id,
      });

      if (response.data.noMoreMessages) {
        this.noloadMore = true;
        clearInterval(this.intervalCheck);
      }
      const oldMessages = this.formatMessages(response.data.previousMessages);

      const element: any = document.getElementById('messages-content');

      this.messages = this.messages.concat(oldMessages).sort(this.sortMessages);
      // await this.general.sleep(100);
      // TODO Need fix in future
      element.scroll({
        top: 80,
        left: 0,
        behavior: 'auto',
      });
    } catch (error) {
      console.log(error);
      await this.general.showDanger();
      this.noloadMore = true;
    } finally {
      this.loading = false;
    }
  }

  initInterval() {
    // Init Check
    this.noloadMore = false;
    this.intervalCheck = setInterval(async () => {
      const res = this.isAtTop();
      if (this.noloadMore) {
        clearInterval(this.intervalCheck);
        return;
      }
      if (res) {
        await this.loadMoreMessages();
      }
    }, 1000);
  }

  async scrollToBottom() {
    const element: any = document.getElementById('messages-content');
    element.scroll({
      top: element.scrollHeight,
      left: 0,
      behavior: 'auto',
    });
  }

  validateForm() {
    return (formGroup: FormGroup) => {
      let res = null;

      // return if another validator has already found an error on the matchingControl
      if (formGroup.errors && !formGroup.errors.badOrder) {
        return;
      }

      const controlMessage = formGroup.controls['message'];
      const controlFile = formGroup.controls['file'];

      if (!controlMessage.value && !controlFile.value) {
        controlMessage.setErrors({ needValue: true });
        return;
      }
      controlMessage.setErrors(null);
    };
  }

  async sendMessage() {
    
    window.addEventListener('app:new-message', this.form.value);
    try {
      this.sendingMessage = true;
      const formData: any = new FormData();
      formData.append('message', this.form.value.message);
      formData.append('to_user', this.chatSelected);

      if (this.form.value.file) {
        formData.append('files[]', this.form.value.file);
      }

      const response = await this.general.httpPost(
        'chat/send-message',
        formData
      );
      this.messages.push(this.formatMessage(response.data));
      this.form.patchValue({
        message: '',
        file: '',
      });
      await this.general.sleep(10);
      await this.scrollToBottom();
    } catch (error:any) {
      console.log("Ctr chat", error);
      await this.general.showDanger(error.errors.message[0]);
    } finally {
      this.sendingMessage = false;
    }
  }

  async onFileSelect(event: any) {
    if (event.files.item(0)) {
      // CheckSize
      if (event.files.item(0).size > 52428800) {
        await this.general.showDanger('file-to-big');
        return;
      }

      this.form.patchValue({
        file: event.files.item(0),
      });
    }
  }

  removeFile() {
    this.form.patchValue({
      file: '',
    });
  }

  onMessageClick(message: any) {
    if (!message.files.length) {
      return;
    }
    window.open(message.files[0].url);
  }
}

